import { makeStyles } from '@material-ui/core/styles';


export const useCellStyles = makeStyles(() => ({
  head: {
    backgroundColor: '#fff',
    fontSize: '0.82rem',
    fontWeight: 600,
    height: 40,
    padding: '5px 10px',
    textTransform: 'capitalize',
  },
  cell: {
    fontSize: '0.82rem',
    padding: '5px 10px',
    whiteSpace: 'nowrap',
  },
}));